const SOURCE_FILE_TYPE = {
  ORDER_ID: 'order_id',
  EXTERNAL_URL: 'external_url',
  OWN_FILE: 'own_file',
  UNSTANDARDIZED: 'unstandardized'
};

export default SOURCE_FILE_TYPE;
